import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom"
import SpecialistRoutes from "./specialist.routes"
// import { checkUserType } from "../utils/helper"
import NotFound from "../pages/Guest/NotFound"
import MemberRoutes from "./member.routes"
import GuestRoutes from "./guest.routes"

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {GuestRoutes}
      {MemberRoutes}
      {SpecialistRoutes}
      {/* {
        checkUserType() === "specialist" ?
          SpecialistRoutes : null
      }
      {
        checkUserType() === "member" ?
          MemberRoutes : null
      } */}
      <Route path="*" element={<NotFound />} />
    </>
  )
)

export default router